import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat } from '../../../../../../../utils/creative-image-router-helper';
import { GmailAdEuMobileShellComponent } from './gmail-ad-eu-mobile-shell.component';

/** Gmail EU mobile ad previewing the portrait 960x1200 upload. */
@Component({
    selector: 'app-gen-gmail-ad-eu-mobile-portrait',
    imports: [GmailAdEuMobileShellComponent],
    template: '<app-gen-gmail-ad-eu-mobile-shell [data]="data" [creativeFormat]="creativeFormat" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class GmailAdEuMobilePortraitPreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  readonly creativeFormat: CreativeFormat = 'portrait';
}
